<ng-container *ngIf="pages?.length > 0">
    <nav aria-label="Pagination" role="navigation">
        <ul class="pagination justify-content-center align-items-center">
            <li *ngIf="!(selectedIndex == 1)" class="page-item page-prev">
                <a class="page-link" href="javascript:void(0);" title="Page précédente" (click)="changerPagePrecedente()">
                    <svg class="svg-icon svg-angle-left" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-left"></use></svg>
                    <span class="sr-only">Page précédente</span>
                </a>
            </li>

            <div *ngFor="let in of pages; let i = index">
                <li class="page-item" [ngClass]="{'active': selectedIndex == (i+1)}">
                    <a class="page-link" href="javascript:void(0);" (click)="changerPage(i+1)"><span class="sr-only">Page</span>{{i + 1}}</a>
                </li>
            </div>

            <li *ngIf="!(selectedIndex == pages?.length)" class="page-item page-next">
                <a class="page-link" href="javascript:void(0);" title="Page suivante" (click)="changerPageSuivante()">
                    <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false"><use xlink:href="../../../assets/svg-icons/icon-sprite.svg#angle-right"></use></svg>
                    <span class="sr-only">Page suivante</span>
                </a>
            </li>
        </ul>
    </nav>
</ng-container>
